import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import estilos from '../../Tabs/TabsInspeccionarComponent.module.css'
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { useContext } from 'react';
import InspectorEnCampoContext from '../../../Context/InspectorEnCampoContext';
import { getanexoByIdInforme } from '../../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { insertFotoGaleria } from '../../../../../redux/DucksUnidadInspeccion/FotogaleriaDuck';
import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import SeccionFotogaleriaComponent from './SeccionFotogaleriaComponent';

function FotoFaleriaEnvasadoComponent(props) {

    const dispatch = useDispatch();

    const { fotoGaleriaContext, setContextFotoGaleria } = useContext(InspectorEnCampoContext);

    const [isContext, setIsContext] = React.useState(false);

    const [fotosVistaGeneral, setfotosVistaGeneral] = React.useState([]);
    const [fotosAlmacenGranel, setfotosAlmacenGranel] = React.useState([]);
    const [fotosEquipoFiltrado, setfotosEquipoFiltrado] = React.useState([]);
    const [fotosEquipoLlenado, setfotosEquipoLlenado] = React.useState([]);
    const [fotosEquipoTaponado, setfotosEquipoTaponado] = React.useState([]);
    const [fotosEquipoSellado, setfotosEquipoSellado] = React.useState([]);
    const [fotosAlmacenProductoEnvasado, setfotosAlmacenProductoEnvasado] = React.useState([]);
    const [fotosMarcas, setfotosMarcas] = React.useState([]);
    const [fotosAreasAlmacen, setfotosAreasAlmacen] = React.useState([]);
    const [fotosLineasEnvasado, setfotosLineasEnvasado] = React.useState([]);
    const [fotosMarcasOtros, setfotosMarcasOtros] = React.useState([]);

    //AREAS DIVERSAS
    const [fotosLaboratorio, setFotosLaboratorio] = React.useState([]);
    const [fotosSanitarios, setFotosSanitarios] = React.useState([]);
    const [fotosEstacionamiento, setFotosEstacionamiento] = React.useState([]);
    const [fotosOficinas, setFotosOficinas] = React.useState([]);
    const [fotosCarga, setFotosCarga] = React.useState([]);
    const [fotosOtros, setFotosOtros] = React.useState([]);

    const todo = props.todo;
    const idinforme = props.idinforme;
    const idanexo = useSelector(store => store.anexo.anexo);
    const instalacion = props.instalacion - 1;

    React.useEffect(() => {
        if (idinforme?.idfi_25_informecumplimientonom) {
            dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        }
        if (fotoGaleriaContext != null) {
            setfotosVistaGeneral(fotoGaleriaContext.fotosVistaGeneral)
            setfotosAlmacenGranel(fotoGaleriaContext.fotosAlmacenGranel)
            setfotosEquipoFiltrado(fotoGaleriaContext.fotosEquipoFiltrado)
            setfotosEquipoLlenado(fotoGaleriaContext.fotosEquipoLlenado)
            setfotosEquipoTaponado(fotoGaleriaContext.fotosEquipoTaponado)
            setfotosEquipoSellado(fotoGaleriaContext.fotosEquipoSellado)
            setfotosAlmacenProductoEnvasado(fotoGaleriaContext.fotosAlmacenProductoEnvasado)
            setfotosMarcas(fotoGaleriaContext.fotosMarcas)
            setfotosAreasAlmacen(fotoGaleriaContext.fotosAreasAlmacen)
            setfotosLineasEnvasado(fotoGaleriaContext.fotosLineasEnvasado)
            setfotosMarcasOtros(fotoGaleriaContext.fotosMarcasOtros)
            console.log(fotoGaleriaContext)
            setFotosLaboratorio(fotoGaleriaContext.fotosLaboratorio)
            setFotosSanitarios(fotoGaleriaContext.fotosSanitarios)
            setFotosEstacionamiento(fotoGaleriaContext.fotosEstacionamiento)
            setFotosOficinas(fotoGaleriaContext.fotosOficinas)
            setFotosCarga(fotoGaleriaContext.fotosCarga)
            setFotosOtros(fotoGaleriaContext.fotosOtros)
            setIsContext(true)
        }
    }, [])

    React.useEffect(() => {
        const data = {
            fotosVistaGeneral: fotosVistaGeneral,
            fotosAlmacenGranel: fotosAlmacenGranel,
            fotosEquipoFiltrado: fotosEquipoFiltrado,
            fotosEquipoLlenado: fotosEquipoLlenado,
            fotosEquipoTaponado: fotosEquipoTaponado,
            fotosEquipoSellado: fotosEquipoSellado,
            fotosAlmacenProductoEnvasado: fotosAlmacenProductoEnvasado,
            fotosMarcas: fotosMarcas,
            fotosAreasAlmacen: fotosAreasAlmacen,
            fotosLineasEnvasado: fotosLineasEnvasado,
            fotosMarcasOtros: fotosMarcasOtros,
            fotosLaboratorio: fotosLaboratorio,
            fotosSanitarios: fotosSanitarios,
            fotosEstacionamiento: fotosEstacionamiento,
            fotosOficinas: fotosOficinas,
            fotosCarga: fotosCarga,
            fotosOtros: fotosOtros,
            submit: true
        }

        setContextFotoGaleria(data)
    }, [fotosVistaGeneral, fotosAlmacenGranel, fotosEquipoFiltrado, fotosEquipoLlenado, fotosEquipoTaponado, fotosEquipoSellado, fotosAlmacenProductoEnvasado, fotosMarcas, fotosAreasAlmacen, fotosLineasEnvasado, fotosMarcasOtros]);


    const handleVistaGeneral = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosVistaGeneral([...fotosVistaGeneral, event.target.files[0]]);
        }
    }
    const handleAlmacenGeneral = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosAlmacenGranel([...fotosAlmacenGranel, event.target.files[0]]);
        }
    }
    const handleEquipoFiltrado = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosEquipoFiltrado([...fotosEquipoFiltrado, event.target.files[0]]);
        }
    }
    const handleEquipoLlenado = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosEquipoLlenado([...fotosEquipoLlenado, event.target.files[0]]);
        }
    }
    const handleEquipoTaponado = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosEquipoTaponado([...fotosEquipoTaponado, event.target.files[0]]);
        }
    }
    const handleEquipoSellado = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosEquipoSellado([...fotosEquipoSellado, event.target.files[0]]);
        }
    }

    const handleAlmacenProductoEnvasado = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosAlmacenProductoEnvasado([...fotosAlmacenProductoEnvasado, event.target.files[0]]);
        }
    }

    const handleMarcas = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosMarcas([...fotosMarcas, event.target.files[0]]);
        }
    }

    const handleAreasAlmacen = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosAreasAlmacen([...fotosAreasAlmacen, event.target.files[0]]);
        }
    }

    const handleLineasEnvasado = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosLineasEnvasado([...fotosLineasEnvasado, event.target.files[0]]);
        }
    }

    const handleMarcasOtros = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosMarcasOtros([...fotosMarcasOtros, event.target.files[0]]);
        }
    }

    //

    const handleLaboratorio = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosLaboratorio([...fotosLaboratorio, event.target.files[0]]);
        }
    }
    const handleSanitarios = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosSanitarios([...fotosSanitarios, event.target.files[0]]);
        }
    }
    const handleEstacionamiento = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosEstacionamiento([...fotosEstacionamiento, event.target.files[0]]);
        }
    }
    const handleOficinas = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosOficinas([...fotosOficinas, event.target.files[0]]);
        }
    }
    const handleCarga = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosCarga([...fotosCarga, event.target.files[0]]);
        }
    }
    const handleOtros = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosOtros([...fotosOtros, event.target.files[0]]);
        }
    }

    return (
        <Fragment>
            <Formik
                initialValues={{}}
                validate={(valores) => {

                    const data = {
                        fotosVistaGeneral: fotosVistaGeneral,
                        fotosAlmacenGranel: fotosAlmacenGranel,
                        fotosEquipoFiltrado: fotosEquipoFiltrado,
                        fotosEquipoLlenado: fotosEquipoLlenado,
                        fotosEquipoTaponado: fotosEquipoTaponado,
                        fotosEquipoSellado: fotosEquipoSellado,
                        fotosAlmacenProductoEnvasado: fotosAlmacenProductoEnvasado,
                        fotosMarcas: fotosMarcas,
                        fotosAreasAlmacen: fotosAreasAlmacen,
                        fotosLineasEnvasado: fotosLineasEnvasado,
                        fotosMarcasOtros: fotosMarcasOtros,
                        fotosLaboratorio: fotosLaboratorio,
                        fotosSanitarios: fotosSanitarios,
                        fotosEstacionamiento: fotosEstacionamiento,
                        fotosOficinas: fotosOficinas,
                        fotosCarga: fotosCarga,
                        fotosOtros: fotosOtros,
                        submit: false
                    }

                    setContextFotoGaleria(data)
                }}
                onSubmit={(valores) => {
                    //console.log(valores)
                }}
            >
                {(props) => (
                    <div className='mt-5'>
                        <hr></hr>
                        <div className='row mb-3'>
                            <label className={`${estilos.labelUI} mb-2`}>VISTA GENERAL DE LAS INSTALACIONES (INTERIOR Y EXTERIOR)</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Vista general de las instalaciones (Interior y exterior)'} valores={fotosVistaGeneral} metodo={handleVistaGeneral} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>ALMACÉN DE PRODUCTO A GRANEL</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Almacén de producto a granel'} valores={fotosAlmacenGranel} metodo={handleAlmacenGeneral} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>EQUÍPO DE FILTRADO</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Equípo de filtrado'} valores={fotosEquipoFiltrado} metodo={handleEquipoFiltrado} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>EQUÍPO DE LLENADO</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Equípo de llenado'} valores={fotosEquipoLlenado} metodo={handleEquipoLlenado} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>EQUÍPO DE TAPONADO</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Equípo de taponado'} valores={fotosEquipoTaponado} metodo={handleEquipoTaponado} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>EQUÍPO DE SELLADO</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Equípo de sellado'} valores={fotosEquipoSellado} metodo={handleEquipoSellado} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>ALMACÉN DE PRODUCTO DE ENVASADO Y/O TERMINADO</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Almacém de producto envasado y/o terminado'} valores={fotosAlmacenProductoEnvasado} metodo={handleAlmacenProductoEnvasado} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>MARCA(S) (FRENTE Y CONTRA)</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Marca(s) (frente y contra)'} valores={fotosMarcas} metodo={handleMarcas} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>ÁREA DE ALMACÉN DE INSUMOS (TAPONES, BOTELLAS, CAJAS, ETC)</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Área de almacén de insumos (tapones, botellas, cajas, etc.)'} valores={fotosAreasAlmacen} metodo={handleAreasAlmacen} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>LÍNEAS DE ENVASADO PARA OTROS PRODUCTOS ALCHÓLICOS</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Líneas de envasado para otros productos alcohólicos'} valores={fotosLineasEnvasado} metodo={handleLineasEnvasado} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>MARCA(S) (FRENTE Y CONTRA) DE OTROS PRODUCTOS ALCOHÓLICOS</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Marca(s) (frente y contra) de otros productos alcohólicos'} valores={fotosMarcasOtros} metodo={handleMarcasOtros} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>ÁREAS DIVERSAS</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Laboratorio'} valores={fotosLaboratorio} metodo={handleLaboratorio} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Sanitarios'} valores={fotosSanitarios} metodo={handleSanitarios} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Estacionamiento'} valores={fotosEstacionamiento} metodo={handleEstacionamiento} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Oficinas'} valores={fotosOficinas} metodo={handleOficinas} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Equipo de carga (patines, montacargas)'} valores={fotosCarga} metodo={handleCarga} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Otros'} valores={fotosOtros} metodo={handleOtros} />
                            <hr></hr><br /><br />
                        </div>
                    </div>
                )}
            </Formik>
        </Fragment>
    );
};


export default withRouter(FotoFaleriaEnvasadoComponent)
